import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ssoAuthCallbackPath, ssoAuthMaxAgeMs } from '../../../config/environments';

const BOOT_KEY = 'candor_sso_boot';

/**
 * Completes SSO when IIS served public/auth/callback/index.html (no SPA rewrite).
 * That static page stores query in sessionStorage and redirects to /.
 */
export default function SsoBootHandoff() {
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    let raw;
    try {
      raw = sessionStorage.getItem(BOOT_KEY);
      sessionStorage.removeItem(BOOT_KEY);
    } catch (_) {
      return;
    }
    if (!raw) return;
    let payload;
    try {
      payload = JSON.parse(raw);
    } catch (_) {
      return;
    }
    if (!payload || typeof payload !== 'object') return;
    if (payload.ts && Date.now() - Number(payload.ts) > ssoAuthMaxAgeMs()) return;
    const expected = ssoAuthCallbackPath();
    const path = payload.path === expected ? expected : null;
    if (!path) return;
    const search = typeof payload.search === 'string' ? payload.search : '';
    const hash = typeof payload.hash === 'string' ? payload.hash : '';
    navigate(`${path}${search}${hash}`, { replace: true });
  }, [navigate]);

  return null;
}
